import React, { useState, useEffect } from 'react';
import PageLoader from '../components/PageLoader';
import { api } from '../App';
import '../styles/AdminBestellingDetailsPage.css';
import { exportBestellingPdf } from '../utils/exportOrderListPdf';

function AdminBestellingDetailsPage({ user, bestellingId, speltak_naam, onBack, onLogout }) {
  const [bestelling, setBestelling] = useState(null);
  const [regels, setRegels] = useState([]);
  const [vrijeRegels, setVrijeRegels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const fetchBestellingDetails = async () => {
      try {
        const response = await api.get(`/index.php?action=bestellingdetails&bstlid=${bestellingId}`);
        if (cancelled) return;
        setBestelling(response.data.bestelling);
        setRegels(response.data.regels);
        setVrijeRegels(response.data.vrije_regels || []);
        setLoading(false);
      } catch (err) {
        if (cancelled) return;
        setError('Fout bij laden van bestelling');
        setLoading(false);
      }
    };

    fetchBestellingDetails();
    return () => {
      cancelled = true;
    };
  }, [bestellingId]);

  const handlePrint = () => {
    window.print();
  };

  const handleExportPdf = () => {
    if (!bestelling) return;
    if (regels.length === 0 && vrijeRegels.length === 0) return;
    exportBestellingPdf({
      speltak_naam,
      bestelling,
      regels,
      vrijeRegels
    });
  };

  if (loading) {
    return <PageLoader />;
  }

  if (!bestelling) {
    return (
      <div className="admin-bestelling-details-container">
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
          <p>Bestelling niet gevonden</p>
          <button onClick={onBack} className="primary-button">Terug</button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-bestelling-details-container">
      <header className="admin-header no-print">
        <button onClick={onBack} className="back-button">← Terug</button>
        <h1>Bestellingdetails</h1>
        <div className="header-actions">
          {(regels.length > 0 || vrijeRegels.length > 0) && (
            <button type="button" onClick={handleExportPdf} className="export-pdf-button">
              PDF export
            </button>
          )}
          <button type="button" onClick={handlePrint} className="print-button">🖨️ Print</button>
          <button onClick={onLogout} className="logout-button">Uitloggen</button>
        </div>
      </header>

      <main className="admin-main">
        <div className="details-wrapper">
          {error && <div className="error-message no-print">{error}</div>}

          <div className="printable-area">
            {/* Header Info */}
            <div className="bestelling-header-info">
              <div className="header-info-row">
                <div className="info-column">
                  <label>Speltak:</label>
                  <strong>{speltak_naam}</strong>
                </div>
                <div className="info-column">
                  <label>Bestel ID:</label>
                  <strong>#{bestelling.ID}</strong>
                </div>
              </div>
              <div className="header-info-row">
                <div className="info-column">
                  <label>Besteldatum:</label>
                  <strong>{bestelling.besteldatum}</strong>
                </div>
                <div className="info-column">
                  <label>Leverdatum:</label>
                  <strong>{bestelling.leverdatum}</strong>
                </div>
              </div>
              <div className="header-info-row">
                <div className="info-column">
                  <label>Status:</label>
                  <strong className={`status status-${bestelling.status === 0 ? 'open' : 'gesloten'}`}>
                    {bestelling.status === 0 ? 'Open' : 'Gesloten'}
                  </strong>
                </div>
              </div>
              {bestelling.notitie && (
                <div className="header-info-row bestelling-notitie-row">
                  <div className="info-column info-column-full">
                    <label>Notitie:</label>
                    <p className="bestelling-notitie-text">{bestelling.notitie}</p>
                  </div>
                </div>
              )}
            </div>

            {/* Orders Table */}
            <div className="orders-section">
              <h2>Bestelling</h2>
              {regels.length === 0 && vrijeRegels.length === 0 ? (
                <p>Geen regels gevonden</p>
              ) : (
                <table className="details-table">
                  <thead>
                    <tr>
                      <th>Hoeveelheid</th>
                      <th>Product</th>
                      <th>Eenheid</th>
                    </tr>
                  </thead>
                  <tbody>
                    {regels.map((regel) => (
                      <tr key={regel.ID}>
                        <td className="quantity">{regel.hoeveelheid}</td>
                        <td>{regel.product}</td>
                        <td>{regel.eenheid || '-'}</td>
                      </tr>
                    ))}
                    {vrijeRegels.map((regel) => (
                      <tr key={`vrij-${regel.ID}`}>
                        <td className="quantity">{regel.hoeveelheid}</td>
                        <td>{regel.omschrijving} <span className="anders-label">(Anders)</span></td>
                        <td>-</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default AdminBestellingDetailsPage;
